import React from 'react';
import { useTranslation } from 'react-i18next';
import { Popup } from '_atoms';

interface PopupDiscardPromotionRequestProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const PopupDiscardPromotionRequest: React.FC<PopupDiscardPromotionRequestProps> = ({
  open,
  onClose,
  onConfirm,
}) => {
  const { t } = useTranslation();

  return (
    <Popup
      open={open}
      title={t('translation:create_promotion_request.title_discard_changes')}
      cancelButtonProps={{
        onClick: onClose,
        children: t('translation:create_promotion_request.button_back_to_page'),
      }}
      okButtonProps={{ onClick: onConfirm, children: t('translation:create_promotion_request.button_discard') }}
    >
      {t('translation:create_promotion_request.text_changes_not_saved')}
    </Popup>
  );
};
